'use client';

import { createPortal } from 'react-dom';

import SpecialityFilterList from './SpecialityFilterList';

interface SpecialityFilterProps {
  isMobile: boolean;
  open: boolean;
  selectedSpecialities: string[];
  onToggle: (slug: string) => void;
  onClear: () => void;
  onClose: () => void;
}

/**
 * Speciality multi-select. Renders as a bottom sheet on mobile
 * (portalled to body) and as an absolute panel on desktop.
 */
export default function SpecialityFilter({
  isMobile,
  open,
  selectedSpecialities,
  onToggle,
  onClear,
  onClose,
}: SpecialityFilterProps) {
  if (!open) return null;

  const list = (
    <SpecialityFilterList
      selectedSpecialities={selectedSpecialities}
      onToggle={onToggle}
      onClear={onClear}
      onApply={onClose}
    />
  );

  if (isMobile) {
    return createPortal(
      <>
        <div
          className="bg-surface-overlay fixed inset-0 z-40 backdrop-blur-sm"
          onClick={onClose}
        />
        <div className="max-h-searchbar-filter-max-height fixed right-0 bottom-0 left-0 z-50 flex flex-col rounded-t-3xl bg-white px-6 pt-6 pb-8 shadow-xl">
          <div className="mb-5 flex items-center justify-between">
            <span className="text-text-strong text-body-lg font-bold">
              Select a Speciality
            </span>
            <button
              onClick={onClose}
              className="text-gray-400 transition-colors hover:text-gray-600"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>
          <div className="flex-1 overflow-y-auto">{list}</div>
        </div>
      </>,
      document.body,
    );
  }

  return (
    <div className="absolute top-full right-4 z-9999 mt-2 sm:right-45 xl:right-32.5">
      <div className="shadow-searchbar-filter w-72 rounded-2xl border border-gray-100 bg-white p-5">
        {list}
      </div>
    </div>
  );
}
